import React, { useState } from 'react';
import { FiEdit } from 'react-icons/fi';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';

const SetupForm = ({ onCardSaved, setShowForm }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [isLoading, setIsLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        setIsLoading(true);
        const { error: submitError } = await elements.submit();
        if (submitError) { setIsLoading(false); return; }
        const { error, setupIntent } = await stripe.confirmSetup({
            elements,
            confirmParams: { return_url: window.location.href },
            redirect: 'if_required'
        });

        if (error) { toast.error(error.message) }
        else if (setupIntent?.status === 'succeeded') {
            setIsSaved(true);
            if (onCardSaved) { onCardSaved() }
        }
        setIsLoading(false);
    }

    const handleEdit = () => { setIsSaved(false) }

    if (isSaved) {
        return (
            <div className="p-6 border border-green-400 rounded-xl bg-green-50 text-center">
                <h3 className="text-green-600 font-semibold text-xl mb-2">Card Saved Successfully</h3>
                <p className="text-gray-600 mb-6">Your card is now securely saved for future payments.</p>
                <div className="flex gap-4 justify-center">
                    <button onClick={handleEdit} className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center gap-2">
                        <FiEdit /> Change Card
                    </button>

                    <button onClick={() => window.location.reload()} className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">
                        Done
                    </button>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className='card shadow-lg border-0 rounded-4 p-4'>
            <PaymentElement />
            <div className='d-flex gap-2'>
                <button type="submit" disabled={!stripe || isLoading} className="main-btn mt-4 w-25">
                    {isLoading ? "Saving Card..." : "Save Card"}
                </button>
                <button className="main-outline-btn mt-4 w-25" onClick={() => setShowForm(false)}>Cancel</button>
            </div>
        </form>
    );
};

export default SetupForm;